var global = require('../internals/global');
var toPositiveInteger = require('../internals/to-positive-integer');

var RangeError = global.RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/to-offset.js
// module id = 284
// module chunks = 49